export default "__VITE_ASSET__ba5091ef__"